import couponService from 'services/coupon-service';
import couponType from 'enums/coupon-type';

const defaultCoupon = {
  id: null,
  code: null,
  type: couponType.Amount,
  value: null,
  isActive: true
};

const state = {
  coupon: defaultCoupon
};

const actions = {
  async loadCoupon({ commit }, id) {
    commit('coupon-loaded', id ? await couponService.get(id) : { ...defaultCoupon });
  },

  async saveCoupon({ state, commit }) {
    state.coupon.id
      ? await couponService.update(state.coupon)
      : await couponService.create(state.coupon);

    commit('coupon-saved');
  }
};

const mutations = {
  'coupon-loaded'(state, coupon) {
    state.coupon = coupon;
  },

  'coupon-saved'() { }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
}